import React from "react";
import { useParams } from "react-router-dom";
import { getOldDataByName, getPanelJodiChartDetailData, trimAndSplitJodi } from "../../util";
import "./css/style.min.css";
import "./css/matkaplay.css";
import "../common.css";
import ScrollToTop from "../../services/scrollToTop";

const JodiChartDetailScreen = ({ data }) => {
  const params = useParams();
  const gameNameVal = params.gameName;
  
  const oldData = getOldDataByName(gameNameVal);

  return (
    <>
      <div className="container round_border_card">
        <h2 className="white-header">{gameNameVal}</h2>
        <div className="panel-detail">
          <table>
            <tbody>
              <tr>
                <th>Mon</th>
                <th>Tue</th>
                <th>Wed</th>
                <th>Thu</th>
                <th>Fri</th>
                <th>Sat</th>
                <th>Sun</th>
              </tr>
              {oldData?.data?.map((item, index) => {
                return (
                  <tr key={`table-jodi-old-${item.mo}${index}`}>
                    <td>
                      <div className="panel-detail-td">
                        <span>{trimAndSplitJodi(item.mo)}</span>
                      </div>
                    </td>
                    <td>
                      <div className="panel-detail-td">
                      <span>{trimAndSplitJodi(item.tu)}</span>
                      </div>
                    </td>
                    <td>
                      <div className="panel-detail-td">
                      <span>{trimAndSplitJodi(item.we)}</span>
                      </div>
                    </td>
                    <td>
                      <div className="panel-detail-td">
                      <span>{trimAndSplitJodi(item.th)} <br /></span>
                      </div>
                    </td>
                    <td>
                      <div className="panel-detail-td">
                      <span>{trimAndSplitJodi(item.fr)}</span>
                      </div>
                    </td>
                    <td>
                      <div className="panel-detail-td">
                      <span>{trimAndSplitJodi(item.sa)}</span>
                      </div>
                    </td>
                    <td>
                      <div className="panel-detail-td">
                      <span>{trimAndSplitJodi(item.su)}</span>
                      </div>
                    </td>
                  </tr>
                );
              })}
              {getPanelJodiChartDetailData(data, gameNameVal)?.map((item, index) => {
                return (
                  <tr key={`table-jodi-${item.weekIntervalTime}_${index}`}>
                    <>
                      {item.dayWiseData.map((day, innerIndex) => {
                        return (
                          <td key={`table-jodi-${day.name}_${innerIndex}`}>
                            <div className="panel-detail-td">
                              <span>{day.winnerValue}</span><br />
                            </div>
                          </td>
                        );
                      })}
                    </>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
      <ScrollToTop />
    </>
  );
};

export default JodiChartDetailScreen;
